import "..//Main.scss";
import "../../lib/form/form.scss";
import "./Customerqa.scss";
import Sub from "../Sub";
import {
  MdHomeFilled,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { Link, Routes, Route, useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FiSearch } from "react-icons/fi";
import { MdClose } from "react-icons/md";
// import CustomerqaDetail from "./CustomerqaDetail";
import Swal from "sweetalert2";
import ApplyForm from "./ApplyForm";
import axios from "axios";
function Customerqa() {
  let navigate = useNavigate();
  const [applyFormVisible, setApplyFormVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [menuData, setMenuData] = useState([]);
  const [selectValue, setSelectValue] = useState("");

  const selectChange = (event) => {
    setSelectValue(event.target.value);
  };
  const closeModal = () => {
    setShowModal(false);
    setSelectValue("");
  };
  const qaApply = async () => {
    setShowModal(true);
    try {
      const response = await axios.get("/api/workflow");
      setMenuData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const goProcess = () => {
    if (selectValue === "") {
      Swal.fire({
        icon: "error",
        title: "오류",
        html: "분야를 선택해주세요",
        confirmButtonColor: "dodgerBlue",
      });
    }
    let tempData = menuData
      .filter((el) => el.name === selectValue)[0]
      .taskGroups.filter((ele) => ele.type === 9);
    if (tempData.length > 0) {
      let tempObj = {};
      tempObj.id = tempData;
      navigate("/request/institution", { state: tempObj });
    } else {
      Swal.fire({
        icon: "error",
        title: "오류",
        html: "관리자에 문의해주세요",
        confirmButtonColor: "dodgerBlue",
      });
    }
  };
  let { id } = useParams();
  return (
    <>
      {showModal === true ? (
        <div className="popup_bg_bbs ">
          <div
            className="password_change "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>분야선택</h1>
            </div>
            <section className="customcenter_title_row">
              <div className="select_box_contain">
                <div
                  className="select_box"
                  style={{ padding: "20px 20px 0 20px" }}
                >
                  <select name="all" onChange={selectChange}>
                    <option value="" selected disabled>
                      분야
                    </option>
                    {menuData.map((e) => (
                      <>
                        <option value={e.name}>{e.name}</option>
                      </>
                    ))}
                  </select>
                </div>
              </div>
            </section>
            <div style={{ padding: "20px" }}>
              <div style={{ display: "flex", gap: "3px" }}>
                <button
                  className="btn_none"
                  type="button"
                  style={{ width: "100%" }}
                  onClick={closeModal}
                >
                  취소
                </button>
                <button
                  className="btn_color"
                  type="button"
                  style={{ width: "100%" }}
                  onClick={goProcess}
                >
                  접수신청
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <Sub to={"/customerqa"} title="이의불만분쟁" />
      <div className="">
        <div className="customcenter_area">
          <section className="customcenter_title_row">
            <div className="customcenter_title_col">
              <p>이의불만분쟁접수</p>
              <button
                className="btn_color"
                // onClick={() => setApplyFormVisible(!applyFormVisible)}
                onClick={qaApply}
              >
                신청
              </button>
            </div>
            <p className="customcenter_title_col">
              검토가 시작되면 상세정보를 확인할 수 있습니다.
            </p>
          </section>
          <section className="input_area">
            <div className="input_wrap">
              <input
                className="input_line"
                type="text"
                placeholder="접수번호를 입력하세요."
              />
            </div>
            <div className="input_wrap">
              <input className="input_line" type="text" placeholder="업체명" />
            </div>
          </section>
          <section className="select_box_area">
            <div className="select_box_contain">
              <div className="select_box">
                <select name="all">
                  <option value="" selected>
                    접수분야
                  </option>
                </select>
              </div>
              <div className="select_box">
                <select name="all">
                  <option value="" selected>
                    신청분야
                  </option>
                </select>
              </div>
            </div>
            <div className="select_box_btns_wrap">
              <button
                className="btn_line"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                초기화
              </button>
              <button
                className="btn_color"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                검색
              </button>
            </div>
          </section>
        </div>
        {applyFormVisible && (
          <ApplyForm
            applyFormVisible={applyFormVisible}
            setApplyFormVisible={setApplyFormVisible}
          />
        )}
        <div className="">
          <form className="my_page bbs_contain" action="" method="">
            <Routes>
              {/* <Route path=":id" element={<CustomerqaDetail />} /> */}
            </Routes>

            <div className="row_bbs bbs_customqa_wrap">
              <table className="table_wrap_customerqa">
                <thead>
                  <tr>
                    <th>접수번호</th>
                    <th>접수분야</th>
                    <th>신청분야</th>
                    <th>접수일</th>
                    <th>처리상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="num_bbs">RN-20220128-0001</td>
                    <td>
                      <p
                        onClick={() => {
                          navigate("/customerqa/0");
                        }}
                      >
                        불만
                      </p>
                    </td>
                    <td>
                      <p className="auth">인정</p>
                    </td>
                    <td className="date_bbs">2022-01-28 13:56:51</td>
                    <td className="date_bbs">종료</td>
                  </tr>
                  <tr>
                    <td className="num_bbs">RN-20220128-0001</td>
                    <td>
                      <p
                        onClick={() => {
                          navigate("/customerqa/0");
                        }}
                      >
                        이의제기
                      </p>
                    </td>
                    <td>
                      <p className="auth">인정</p>
                    </td>
                    <td className="date_bbs">2022-01-28 13:56:51</td>
                    <td className="date_bbs">검토중</td>
                  </tr>
                </tbody>
              </table>

              <div className="pagination_wrap">
                <div></div>
                <div className="pagination">
                  <button className="left_arrow">
                    <MdKeyboardArrowLeft />
                  </button>
                  <div className="pages">
                    <span>1</span>
                    <span>2</span>
                  </div>
                  <button className="right_arrow">
                    <MdKeyboardArrowRight />
                  </button>
                </div>
                <div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/customerqa");
                    }}
                    className="list_btn"
                  >
                    목록
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Customerqa;
